import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000',
    prepareHeaders: (headers) => {
        const adminToken = localStorage.getItem('admin');
        if (adminToken) {
            // Optional: attach token if needed for specific routes
            // headers.set('Authorization', `Bearer ${adminToken}`);
        }
        return headers;
    },
});

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery,
    tagTypes: ['Blog', 'Calendar', 'User', 'SystemLogs'],
    endpoints: (builder) => ({
        getBlogs: builder.query({
            query: ({ search = '', page = 1, status = '' } = {}) => {
                const params = new URLSearchParams({ search, page, limit: 8 });
                if (status) params.append('status', status);
                return `/api/blogs?${params.toString()}`;
            },
            providesTags: ['Blog'],
        }),
        deleteBlog: builder.mutation({
            query: (id) => ({
                url: `/api/blogs/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Blog'],
        }),
        // NOTE: Create and Update blog involve FormData (image upload).
        // fetchBaseQuery handles FormData automatically when passed as body.
        createBlog: builder.mutation({
            query: (formData) => ({
                url: '/api/blogs',
                method: 'POST',
                body: formData,
            }),
            invalidatesTags: ['Blog'],
        }),
        updateBlog: builder.mutation({
            query: ({ id, formData }) => ({
                url: `/api/blogs/${id}`,
                method: 'PUT',
                body: formData,
            }),
            invalidatesTags: ['Blog'],
        }),
        
        // --- CALENDAR ENDPOINTS ---
        getGlobalEvents: builder.query({
            query: ({ start, end }) => `/api/calendar/global-event?start=${start}&end=${end}`,
            providesTags: ['Calendar'],
        }),
        createGlobalEvent: builder.mutation({
            query: (data) => ({
                url: '/api/admin/calendar/events',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Calendar'],
        }),
        updateGlobalEvent: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `/api/admin/calendar/events/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Calendar'],
        }),
        deleteGlobalEvent: builder.mutation({
            query: ({ id, deleteType, eventDate }) => {
                let url = `/api/admin/calendar/events/${id}`;
                if (deleteType && deleteType !== 'all') {
                    url += `?deleteType=${deleteType}&eventDate=${eventDate}`;
                }
                return {
                    url,
                    method: 'DELETE',
                };
            },
        }),
        getSystemLogs: builder.query({
            query: () => '/api/system-logs',
            providesTags: ['SystemLogs'],
        }),
        clearSystemLogs: builder.mutation({
            query: () => ({
                url: '/api/system-logs',
                method: 'DELETE',
            }),
            invalidatesTags: ['SystemLogs'],
        }),
    }),
});

export const {
    useGetBlogsQuery,
    useDeleteBlogMutation,
    useCreateBlogMutation,
    useUpdateBlogMutation,
    useGetGlobalEventsQuery,
    useCreateGlobalEventMutation,
    useUpdateGlobalEventMutation,
    useDeleteGlobalEventMutation,
    useGetSystemLogsQuery,
    useClearSystemLogsMutation
} = apiSlice;
